<script lang="ts">
    import type { Readable, Writable } from 'svelte/store'

    import Icon from '@iconify/svelte'

    import PopEntry from 'hydria/components/PopEntry.svelte'
    import { gettext as _ } from 'hydria/services/gettext'

    import type { ILocalRevision } from './pageDefs'

    interface Props {
        revSaved: Readable<ILocalRevision>
        revEdit: Writable<ILocalRevision>
        disabled: boolean
    }

    let { revSaved, revEdit, disabled }: Props = $props()

    let modalStatusIcon: string = $derived($revEdit && $revSaved && $revEdit.deleg === $revSaved.deleg && $revEdit.modal_signout === $revSaved.modal_signout ? 'mdi:check-circle' : 'mdi:undo')
    let modalStatusClass: string = $derived($revEdit && $revSaved && $revEdit.deleg === $revSaved.deleg && $revEdit.modal_signout === $revSaved.modal_signout ? 'btn-link' : 'btn-outline-danger')
    let modalIsOpen: boolean = $state(false)

    let modalEditModalSignout: boolean = $state()
    let modalEditDeleg: boolean = $state()
    function openModalPop() {
        modalEditModalSignout = $revEdit.modal_signout
        modalEditDeleg = $revEdit.deleg
        modalIsOpen = true
    }
    function closeModalPop(keep: boolean) {
        if (keep) {
            $revEdit.modal_signout = modalEditModalSignout
            $revEdit.deleg = modalEditDeleg
        }
        modalIsOpen = false
    }
</script>

<div class="row g-3 align-items-baseline">
    <div class="col-2 text-end"><label aria-hidden="true" for="f-decon" class="control-label" onclick={() => openModalPop()}>{$_('Déconnexion')}</label></div>
    <div class="col">
        {#if modalIsOpen}
            <PopEntry close={() => closeModalPop(false)}>
                <div class="card">
                    <div class="card-header text-bg-primary">{$_('Afficher dans le modal de déconnexion')}</div>
                    <div class="card-body">
                        <div class="btn-group">
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                class:active={!modalEditModalSignout}
                                onclick={() => {
                                    modalEditModalSignout = false
                                    modalEditDeleg = false
                                }}
                                {disabled}>Non</button
                            >
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                class:active={modalEditModalSignout && !modalEditDeleg}
                                onclick={() => {
                                    modalEditModalSignout = true
                                    modalEditDeleg = false
                                }}
                                {disabled}>Oui</button
                            >
                            <button
                                type="button"
                                class="btn btn-outline-secondary"
                                class:active={modalEditModalSignout && modalEditDeleg}
                                onclick={() => {
                                    modalEditModalSignout = true
                                    modalEditDeleg = true
                                }}
                                {disabled}>Seulement si délégué</button
                            >
                        </div>
                    </div>
                    <div class="card-footer d-flex gap-2 justify-content-end">
                        <button type="button" class="btn btn-sm btn-outline-secondary" onclick={() => closeModalPop(false)}>{$_('Fermer')}</button>
                        <button type="button" class="btn btn-sm btn-primary" onclick={() => closeModalPop(true)}>{$_('Appliquer')}</button>
                    </div>
                </div>
            </PopEntry>
        {/if}
        <div aria-hidden="true" onclick={() => openModalPop()} class="clickable">
            {#if $revEdit.modal_signout && $revEdit.deleg}
                {$_('Afficher dans un modal aux délégués à la déconnexion.')}
            {:else if $revEdit.modal_signout && !$revEdit.deleg}
                {$_('Afficher dans un modal à la déconnexion.')}
            {:else}
                {$_('Ne pas afficher à la déconnexion.')}
            {/if}
        </div>
    </div>
    <div class="col-auto text-end">
        <button
            type="button"
            class="btn btn-sm {modalStatusClass}"
            disabled={$revEdit.deleg === $revSaved.deleg && $revEdit.modal_signout === $revSaved.modal_signout}
            onclick={() => {
                $revEdit.deleg = !!$revSaved.deleg
                $revEdit.modal_signout = !!$revSaved.modal_signout
            }}><Icon inline icon={modalStatusIcon} /></button
        >
        <button type="button" class="btn btn-sm btn-outline-secondary" {disabled} onclick={() => openModalPop()}><Icon inline icon="mdi:edit" /></button>
    </div>
</div>
